import type { IconProps } from '@phosphor-icons/react'
import { APP_ICONS, MARKETPLACE_ICON_CLASS, type AppIconName } from '../../config/appIcons'

export interface AppIconProps {
  name: AppIconName
  size?: number
  weight?: IconProps['weight']
  className?: string
}

/**
 * Renders a Phosphor icon by registry key (see config/appIcons.tsx).
 */
export function AppIcon({ name, size = 20, weight = 'regular', className = '' }: AppIconProps) {
  const Icon = APP_ICONS[name]
  if (!Icon) return null

  const marketplaceColor = MARKETPLACE_ICON_CLASS[name]
  const mergedClassName = [marketplaceColor, className].filter(Boolean).join(' ')
  const resolvedWeight =
    weight === 'regular' && marketplaceColor ? ('fill' as const) : weight

  return (
    <Icon
      size={size}
      weight={resolvedWeight}
      className={mergedClassName || undefined}
      aria-hidden
    />
  )
}
